<template>
  <section :class="getSliderClasses">
    <div ref="glide" class="glide h-100">
      <slot />
    </div>
  </section>
</template>

<script>
import Glide, { Controls, Swipe, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'

export default {
  name: 'CiSlider',

  props: {
    options: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      glide: null,
    }
  },

  computed: {
    getSliderClasses() {
      const classes = ['slider']
      return classes.join(' ')
    },
  },

  mounted() {
    const options = {
      type: 'slider',
      bound: true,
      ...this.options,
    }

    this.$nextTick(() => {
      this.glide = new Glide(this.$refs.glide, options)
      this.glide.on('mount.after', () => {
        this.$emit('init', this.glide)
      })
      this.glide.on('run.after', () => {
        this.$emit('moved', this.glide)
      })
      this.glide.mount({ Controls, Swipe, Breakpoints })
    })
  },

  destroyed() {
    if (this.glide) {
      this.glide.destroy()
    }
  },
}
</script>

<style lang="scss">
@import '~@glidejs/glide/src/assets/sass/glide.core.scss';
@import '~@glidejs/glide/src/assets/sass/glide.theme.scss';
</style>

<style lang="scss">
.slider {
  overflow: hidden;

  .glide__slide {
    height: auto;
  }

  .glide__slides {
    overflow: visible;
  }
}
</style>
